import { ReceiverChannel, SenderChannel } from '@shared/data-provider/app-supporter';

export interface Channel {
  name?: string;
  enabled?: boolean;
  type?: ReceiverChannel.TypeEnum | SenderChannel.TypeEnum;
}

export const CHANNEL_TYPE_LABELS: Record<ReceiverChannel.TypeEnum, string> = {
  active: 'Активный',
  nonActive: 'Неактивный',
  unknown: 'Неизвестный',
};
